/*
 * (c) copyright 2021 International Road Dynamics Inc. and related companies.
 * All rights reserved.
 * Copyright as an unpublished work.
 *
 * This file contains confidential information of International
 * Road Dynamics Inc. and related companies, and should be treated as proprietary
 * and confidential.
 *
 * The use, copying, disclosure or modification of the
 * programs and/or source code is prohibited unless
 * otherwise provided for in the license or confidentiality
 * agreements.
 *
 * Any copy must contain this copyright notice.
 */

import React from 'react'
import PropTypes from 'prop-types'

import {
  InputAdornment,
  TextField
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search'

const useStyles = makeStyles((theme) => ({
  textFieldRoot: {
    marginTop: '1em',
    width: '100%'
  }
}))

function Search (props) {
  const classes = useStyles()

  return (
    <TextField
      classes={{
        root: classes.textFieldRoot
      }}
      id="txtSearch"
      variant="outlined"
      size="small"
      placeholder="Search for sites by name, address, island, latitude, longitude or type"
      label="Search"
      value={props.value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        )
      }}
      onChange={props.onChange}
    />
  )
}

Search.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string
}

Search.defaultProps = {
  value: ''
}

export default Search
